import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import PharmaReplace from '../../components/ReplaceForm/PharmaReplace';
import CallToAction from '../../components/CallToAction';

const ReplaceForm = (props) => {
  return (
    <div className="sign-up full-width replace">
      <div className="top-bar"></div>
      <div className="wrapper">
        <Header as="h1">
          Lost card?
          <Header.Subheader>
            If your patient has misplaced the <span className="nowrap-txt">Takeda Oncology</span> Co-Pay Card, we can help you retrieve his or her information.
          </Header.Subheader>
        </Header>
        <p className="intro-replace">Please provide the following:</p>
        <PharmaReplace
          environment={ props.environment }
          onSubmit={ props.onSubmit }
        />
        <CallToAction id={ 8 }/>
      </div>
    </div>
  );
};

ReplaceForm.propTypes = {
  environment: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ReplaceForm;
